export class StudyProcedureTaskDefinition {
  constructor(params = {}) {
    this.id = params.id;
    this.displayName = params.displayName;
    this.roleIds = params.roleIds;
  }

  listParams({ locked, onClick }) {
    return {
      header: this.displayName,
      id: this.id,
      locked: locked,
      onClick: () => onClick(this.id),
    };
  }
}

export default StudyProcedureTaskDefinition;
